import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7c62964e")

_pushScopeId("data-v-7c62964e")
const _hoisted_1 = { class: "card seq-card h-100" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center mb-5" }
const _hoisted_4 = { class: "fw-bold mb-0 d-flex align-items-center" }
const _hoisted_5 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Recent Activity ")
const _hoisted_7 = { class: "d-flex align-items-center gap-2" }
const _hoisted_8 = {
  type: "button",
  class: "btn btn-sm btn-seq-toolbar d-flex align-items-center"
}
const _hoisted_9 = { class: "svg-icon svg-icon-5 me-1" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Filter ")
const _hoisted_11 = {
  type: "button",
  class: "btn btn-sm btn-seq-toolbar d-flex align-items-center"
}
const _hoisted_12 = { class: "svg-icon svg-icon-5 me-1" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Sort ")
const _hoisted_14 = {
  key: 0,
  class: "text-center py-10 text-muted"
}
const _hoisted_15 = {
  key: 1,
  class: "text-center py-10 text-muted"
}
const _hoisted_16 = {
  key: 2,
  class: "recent-activity-table"
}
const _hoisted_17 = { class: "table align-middle gs-0 gy-4 mb-0" }
const _hoisted_18 = /*#__PURE__*/_createVNode("thead", { class: "recent-activity-thead" }, [
  /*#__PURE__*/_createVNode("tr", { class: "text-muted fw-semibold fs-8 text-uppercase" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-0" }, "Type"),
    /*#__PURE__*/_createVNode("th", null, "Amount"),
    /*#__PURE__*/_createVNode("th", null, "Status"),
    /*#__PURE__*/_createVNode("th", { class: "text-end pe-0" }, "Method")
  ])
], -1)
const _hoisted_19 = { class: "ps-0" }
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = { class: "svg-icon svg-icon-3 svg-icon-white" }
const _hoisted_22 = { class: "fw-semibold text-gray-800" }
const _hoisted_23 = { class: "text-muted fs-8" }
const _hoisted_24 = { class: "fw-semibold text-gray-800" }
const _hoisted_25 = { class: "text-muted fs-8" }
const _hoisted_26 = { class: "text-end pe-0" }
const _hoisted_27 = { class: "fw-semibold text-gray-800" }
const _hoisted_28 = { class: "text-muted fs-8" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DashboardTabNavigator = _resolveComponent("DashboardTabNavigator")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_DashboardTabNavigator),
      _createVNode("div", _hoisted_3, [
        _createVNode("h3", _hoisted_4, [
          _createVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Chart-line1.svg" })
          ]),
          _hoisted_6
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("button", _hoisted_8, [
            _createVNode("span", _hoisted_9, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Text/Filter.svg" })
            ]),
            _hoisted_10
          ]),
          _createVNode("button", _hoisted_11, [
            _createVNode("span", _hoisted_12, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Sort2.svg" })
            ]),
            _hoisted_13
          ])
        ])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock("div", _hoisted_14, "Loading recent activity..."))
        : (_ctx.rows.length === 0)
          ? (_openBlock(), _createBlock("div", _hoisted_15, " No recent activity yet. "))
          : (_openBlock(), _createBlock("div", _hoisted_16, [
              _createVNode("div", {
                ref: "scrollViewport",
                class: "recent-activity-viewport",
                style: _ctx.viewportStyle,
                onMouseenter: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.pauseAutoScroll && _ctx.pauseAutoScroll(...args))),
                onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resumeAutoScroll && _ctx.resumeAutoScroll(...args)))
              }, [
                _createVNode("table", _hoisted_17, [
                  _hoisted_18,
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.loopRows, (row, index) => {
                      return (_openBlock(), _createBlock("tr", {
                        key: `${row.id || 'row'}-${index}`
                      }, [
                        _createVNode("td", _hoisted_19, [
                          _createVNode("div", _hoisted_20, [
                            _createVNode("span", {
                              class: ["seq-stat-tile__icon me-3", row.direction === 'in' ? 'seq-stat-tile__icon--green' : 'seq-stat-tile__icon--blue'],
                              style: {"width":"38px","height":"38px"}
                            }, [
                              _createVNode("span", _hoisted_21, [
                                _createVNode(_component_inline_svg, {
                                  src: row.direction === 'in' ? 'media/icons/duotone/Navigation/Plus.svg' : 'media/icons/duotone/Navigation/Up-2.svg'
                                }, null, 8, ["src"])
                              ])
                            ], 2),
                            _createVNode("div", null, [
                              _createVNode("div", _hoisted_22, _toDisplayString(row.name), 1),
                              _createVNode("div", _hoisted_23, _toDisplayString(row.type) + " · " + _toDisplayString(row.date), 1)
                            ])
                          ])
                        ]),
                        _createVNode("td", null, [
                          _createVNode("div", _hoisted_24, _toDisplayString(row.amount), 1),
                          _createVNode("div", _hoisted_25, _toDisplayString(row.amountAlt), 1)
                        ]),
                        _createVNode("td", null, [
                          _createVNode("span", {
                            class: ["seq-badge", _ctx.badgeClass(row.status)]
                          }, _toDisplayString(row.status), 3)
                        ]),
                        _createVNode("td", _hoisted_26, [
                          _createVNode("div", _hoisted_27, _toDisplayString(row.method), 1),
                          _createVNode("div", _hoisted_28, _toDisplayString(row.methodAlt), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ], 36)
            ]))
    ])
  ]))
})